$(document).ready(function() {
    // apply a change event
    $('.subject').change(function() {
        if ($(this).val() === '3') {
            $('.message').val('Hej!\n\n' +
                'Jag önskar att ni raderar de uppgifter ni har lagrade om mig. Tack!');
        }
    });
});